



































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Account } from '../models/account';
import { Country } from '../models/country';

@Component
export default class Admin extends Vue {

  private dialog: boolean = false;
  private defaultInstagram: string = '';
  private valid: boolean = false;
  private headers = [
    { text: 'Image', value: 'profilePhoto', sortable: false },
    { text: 'Instagram', value: 'instagram' },
    { text: 'Country', value: 'country' },
    { text: 'Reason', value: 'reason' },
    { text: 'Proof', sortable: false },
    { text: 'Type', value: 'type' },
    { text: 'Actions', align: 'start', value: 'id', sortable: false },
  ];
  private types = [
    'Individuo',
    'Negocio',
  ];
  private editedIndex: number = -1;
  private editedItem: Account = {
    country: '',
    instagram: '',
    proof: '',
    reason: '',
    type: '',
    isActive: false,
    profilePhoto: '',
    profilePhotoUrl: '',
    id: '',
  };
  private defaultItem: Account = {
    country: '',
    instagram: '',
    proof: '',
    reason: '',
    type: '',
    isActive: false,
    profilePhoto: '',
    profilePhotoUrl: '',
    id: '',
  };

  private countryRules = [
    (v: string) => !!v && v.length > 0 || 'Country is required',
  ];
  private instagramRules = [
    (v: string) => !!v || 'Instagram is required',
    (v: string) => (v && v.length <= 25) || 'Instagram must be less than 25 characters',
    (v: string) => (v && !v.startsWith('@')) || 'Please remove @ symbol',
    (v: string) => (v && !this.accountExists()) || 'Instagram profile already exists',
  ];
  private proofRules = [
    (v: string) => (v && v.length > 0) || 'Proof is required',
  ];
  private reasonRules = [
    (v: string) => (v && v.length > 0) || 'Reason is required',
  ];
  private typeRules = [
    (v: string) => (v && v.length > 0) || 'Type is required',
  ];

  public created() {
    this.$store.state.instagramQuery = '';
    this.$store.dispatch('getAllAccounts');
  }

  get formTitle() {
    return this.editedIndex === -1 ? 'New Account' : 'Edit Account';
  }

  get accounts() {
    return this.$store.getters.getAllAccounts();
  }

  get countries() {
    return this.$store.getters.getCountriesNames;
  }

  private accountExists() {
    if (this.editedIndex > -1) {
      return this.editedItem.instagram.toLowerCase() === this.defaultInstagram
        ? false
        : this.accounts.some((account: Account) => {
          return account.instagram.replace('@', '') === this.editedItem.instagram.toLowerCase();
        });
    } else {
      return this.accounts.some((account: Account) => {
        return account.instagram.replace('@', '') === this.editedItem.instagram.toLowerCase();
      });
    }
  }

  private initialize() {
    this.$store.dispatch('getAllAccounts');
  }

  private editItem(item: Account) {
    this.editedIndex = this.accounts.indexOf(item);
    this.editedItem = { ...item };
    if (this.editedItem && this.editedItem.instagram) {
      this.editedItem.instagram = this.editedItem.instagram.replace('@', '');
      this.defaultInstagram = this.editedItem.instagram;
    }
    this.dialog = true;
  }

  private deleteItem(item: Account) {
    if (confirm('Are you sure you want to delete this account?')) {
      this.$store.dispatch('fireAccounts/delete', item.id);
    }
  }

  private close() {
    this.dialog = false;
    this.editedItem.instagram = `@${this.defaultInstagram}`;
    this.defaultInstagram = '';
    setTimeout(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    }, 300);
  }

  private save() {
    if (this.editedIndex > -1) {
      const account: Account = { ...this.editedItem };
      account.instagram = `@${account.instagram.toLowerCase()}`;
      this.updateAccount(account);
    } else {
      this.add();
    }
    this.close();
  }

  private add() {
    const account: Account = { ...this.editedItem };
    account.instagram = `@${account.instagram.toLowerCase()}`;
    const instagram = this.editedItem.instagram.replace('@', '');
    fetch(`https://www.instagram.com/${instagram}/?__a=1`)
      .then((response) => {
          if (response.ok) {
            return response.json();
          }
        },
      )
      .then((data) => {
        account.isActive = true;
        account.profilePhotoUrl = data.graphql.user.profile_pic_url_hd as string;
        return account;
      })
      .then((updatedAccount) => {
        fetch(updatedAccount.profilePhotoUrl)
          .then((r) => r.arrayBuffer())
          .then((buffer) => {
            updatedAccount.profilePhoto = btoa(String.fromCharCode(...new Uint8Array(buffer)));
            this.addAccount(updatedAccount);
          });
      })
      .catch((err: string) => {
        account.isActive = false;
        account.profilePhotoUrl = '';
        account.profilePhoto = '';
        this.addAccount(account);
      });
  }

  private addAccount(account: Account): Promise<any> {
    return this.$store.dispatch('fireAccounts/set', account);
  }

  private updateAccount(account: Account): Promise<any> {
    return this.$store.dispatch('fireAccounts/patch', account);
  }
}
